import module from 'nominas/finiquito/module.js'
import template from './template.html'

const calcularComision = (colaborador, idMetodoCalculo, comisionPorcentaje) => {
  switch (idMetodoCalculo) {
    case 1:
      // Calcular comisión sobre el suministro
      const percepciones = Object.values(colaborador.percepciones)
        .reduce((suministro, percepcion) => suministro + percepcion.importe, 0)
      const deducciones = Object.values(colaborador.deducciones)
        .filter((deduccion) => [112, 114, 115, 116, 152].includes(Number(deduccion.id_concepto)))
        .reduce((suministro, deduccion) => suministro + deduccion.importe, 0)
      const suministro = +(percepciones - deducciones).toFixed(2)

      return +(suministro * comisionPorcentaje).toFixed(2)

    case 2:
      // Calcular comisión sobre el neto a pagar
      return +(colaborador.neto_a_pagar * comisionPorcentaje).toFixed(2)

    default:
      return 0
  }
}

export class NominasFiniquitoEscenarioCalculoComponent {
  idProyecto
  idColaborador
  idFiniquito
  idEscenario
  data
  editable = false
  error = null
  modificado = false
  calculando = false

  constructor ($q, CatalogoFiniquitoConceptos, NominasFiniquitoEscenario) {
    this.$q = $q
    this.CatalogoFiniquitoConceptos = CatalogoFiniquitoConceptos
    this.NominasFiniquitoEscenario = NominasFiniquitoEscenario
  }

  $onInit () {
    this.promise = this.$q.all([
      this.NominasFiniquitoEscenario.get(this.idProyecto, this.idColaborador, this.idFiniquito, this.idEscenario)
        .then((response) => {
          this.data = response.data
          this.editable = !this.data.aplicado
        }),
      this.CatalogoFiniquitoConceptos.get({id_proyecto: this.idProyecto})
        .then((response) => {
          this.configuracionConceptos = response.data
          this.percepciones = this.configuracionConceptos.filter((item) => item.naturaleza === 'P')
          this.deducciones = this.configuracionConceptos.filter((item) => item.naturaleza === 'D')
        }),
    ])
  }

  actualizar (data) {
    this.calculando = false

    if (data && data.completado) {
      this.modificado = true
      this.data.colaborador = data.resultado
      this.data.comision_importe = calcularComision(this.data.colaborador, this.data.id_metodo_calculo_comision, this.data.comision_porcentaje)
    }
  }

  calcular () {
    this.error = null
    this.calculando = true
  }

  guardar (calculado) {
    if (!calculado) {
      this.error = 'Para guardar, es necesario calcular el finiquito.'

      return
    }

    this.procesando = true

    this.NominasFiniquitoEscenario.put(this.idProyecto, this.idColaborador, this.idFiniquito, this.idEscenario, this.data)
      .then(() => (this.modificado = false))
      .finally(() => (this.procesando = false))
  }

  modificarPercepciones (data) {
    this.data.colaborador.percepciones = data
    this.modificar()
  }

  modificarDeducciones (data) {
    this.data.colaborador.deducciones = data
    this.modificar()
  }

  modificar () {
    this.modificado = true
    this.data.colaborador.status_calculado = false
  }
}

module.component('nominasFiniquitoEscenarioCalculo', {
  controller: NominasFiniquitoEscenarioCalculoComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    idFiniquito: '<',
    idEscenario: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenario/calculo/component.js